var _path, _path2, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResGridNotesCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC66",
    d: "M25,16c-5,0-9-4-9-9c0-0.3,0-0.7,0.1-1H3C2.4,6,2,6.4,2,7v14c0,0.6,0.4,1,1,1h3v6l6-6h13c0.6,0,1-0.4,1-1v-5.1C25.7,16,25.3,16,25,16z",
    className: "Yellow"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#039C23",
    d: "M25,0c-3.9,0-7,3.1-7,7c0,3.9,3.1,7,7,7s7-3.1,7-7C32,3.1,28.9,0,25,0z",
    className: "Green"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#039C23",
    cx: 24,
    cy: 8,
    r: 4,
    className: "Green"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M21,10l-3,3l-3,3",
    className: "White"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResGridNotesCheck);
export default __webpack_public_path__ + "static/media/resGridNotesCheck.f469d4cd01c8bb2c1487075a1dd60b26.svg";
export { ForwardRef as ReactComponent };